import {
  MAX_CONTAINER_HEIGHT,
  MIN_CONTAINER_HEIGHT,
} from 'src/js/modules/extensions/registry/ws-image/constants/media-container';

const getLimitedHeight = ({ height, minHeight = 0, maxHeight = Infinity }) => {
  const minContainerHeight = Math.max(minHeight, MIN_CONTAINER_HEIGHT);
  const maxContainerHeight = Math.min(maxHeight, MAX_CONTAINER_HEIGHT);

  return Math.max(minContainerHeight, Math.min(height, maxContainerHeight));
};

export default getLimitedHeight;
